"use client";

import ProductSearchBar from "@/app/explore/(components)/ProductSearchBar";
import { useState, useRef, useEffect } from "react";

const HeaderSearch = ({ openSearch, setOpenSearch }) => {
  const searchRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!searchRef.current) return;

      if (!searchRef.current.contains(e.target)) {
        setOpenSearch(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={searchRef}>
      {/* Search Icon */}

      {/* <button
        onClick={(e) => {
          e.stopPropagation();
          setOpenSearch(true);
        }}
        className="my-account-link group"
        aria-label="Open Search"
      >
        <i className="m-icon m-search-icon !w-5 !h-5 bg-white/90 text-xl"></i>
      </button> */}

      {/* Search Bar */}
      {openSearch && (
        <div className="fixed inset-0 bg-black/50 z-10">
          <div className="py-6 sm:py-10 bg-white">
            <ProductSearchBar
              onCancelSearch={() => setOpenSearch(false)}
              placeholder="Search for products, brand and more.."
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderSearch;
